.wrap {
  position: relative;
}

.btn {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  border: 0;
  background: transparent;
  color: #fff;
  cursor: pointer;
  border-radius: 10px;
  transition: background 0.15s ease;
}

.btn:hover,
.btn.active {
  background: rgba(255, 255, 255, 0.1);
}

.panel {
  position: absolute;
  right: 0;
  bottom: calc(100% + 10px);
  width: min(280px, 72vw);
  background: rgba(14, 16, 20, 0.92);
  backdrop-filter: blur(18px) saturate(1.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;
  padding: 14px 16px;
  z-index: 20;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.55);
  text-align: left;
  line-height: 1.35;
  animation: panelIn 0.16s ease;
}

@keyframes panelIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.title {
  margin: 0 0 6px;
  font-size: 14px;
  font-weight: 650;
  color: #fff;
  letter-spacing: -0.01em;
}

.desc {
  margin: 0 0 12px;
  font-size: 12px;
  color: #a8adb8;
}

.stat {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  color: #ddd;
  font-size: 13px;
}

.stat strong {
  display: block;
  color: #fff;
  font-size: 16px;
  font-weight: 650;
}

.stat span {
  color: #a8adb8;
  font-size: 12px;
}
